import React from 'react'
import { Button } from 'fw/components'
import { Col, Row } from 'react-bootstrap'
import { faAddressCard, faHandshake } from '@fortawesome/free-regular-svg-icons'
import { faUsers, faSitemap, faCertificate, faChartLine, faUniversity, faCalculator, faTruck, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faCertificate, faSitemap, faUsers, faAddressCard, faChartLine, faUniversity, faCalculator, faTruck, faFileAlt, faHandshake);

const stepCI = "CI";
const stepDEC = "DEC";

class Navigator extends React.Component {

    constructor() {
        super();
        this.state = {
            intervalId: 0
        };
    }

    handleStepNavigation = (stepCode, validate) => {
        this.props.onStepNavigation(stepCode, validate);
    }

    handleSubmit = () => {
        this.props.onSubmit();
    }

    onStepSave = () => {
        this.props.onStepSave();
    }

    onStepCancel = () => {
        this.props.onStepCancel();
    }

    scrollStep() {
        if (window.scrollY === 0) {
            clearInterval(this.state.intervalId);
        }
        window.scroll(0, window.scrollY - this.props.scrollStepInPx);
    }

    scrollToTop() {
        let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
        this.setState({ intervalId: intervalId });
    }

    render() {
        var enabledStepsCount = this.props.certificationSteps.filter(x => !x.isDisabled).length;
        
        return (
            <React.Fragment>
                {!this.props.showTabs ?
                    (
                        <React.Fragment>
                            <div className="pull-left navigation">
								<Button type="button" id="btnBackToTop" bsStyle="link" title="Back to top"
                                    onClick={() => this.scrollToTop()}>
                                    Back to top
				        	</Button>
                            </div>
                            <div className="pull-right navigation">
                                {(this.props.currentStepInfo.stepCode !== stepCI && this.props.currentStepInfo.prevStepCode) ?
                                    (<Button type="button" id="btnPrevious" bsStyle="default" title="Previous step"
                                        onClick={() => this.handleStepNavigation(this.props.currentStepInfo.prevStepCode, false)}>
                                        Previous
            					</Button>)
                                    : null}
                                &nbsp;&nbsp;
                            <Button type="button" id="btnSave" bsStyle="primary" title="Save application"
                                    onClick={() => this.onStepSave()}>
                                    Save
				        	</Button>
                                &nbsp;&nbsp;
                            <Button type="button" id="btnCancel" bsStyle="danger" title="Cancel application"
                                    onClick={() => this.onStepCancel()}>
                                    Cancel
                            </Button>
                                &nbsp;&nbsp;
                                {this.props.currentStepInfo.stepCode !== stepDEC ?
                                    (<Button type="button" id="btnNext" title="Next step" bsStyle="default"
                                        onClick={() => this.handleStepNavigation(this.props.currentStepInfo.nextStepCode, true)}>
                                        Next
					                </Button>)
                                    : null}
                                {this.props.currentStepInfo.stepCode === stepDEC ?
                                    (<Button type="button" id="btnSubmit" bsStyle="success" title="Submit"
                                        onClick={() => this.handleSubmit()}>
                                        Submit
            					</Button>)
                                    : null}
                            </div></React.Fragment>) : null}
                {this.props.showTabs && this.props.currentStepInfo.isRenewal &&
                    <Row style={{ paddingLeft: '15px', paddingBottom: '5px' }}>
                        <Col xs={12} className="text-right">
                            <a href={'/certification/renewalOneSheet/' + this.props.certificationKey}>
                                Try the One-Sheet form
                            </a>
                        </Col>
                    </Row>
                }
                <Row style={{ paddingLeft: '15px' }}>
                    {this.props.showTabs && enabledStepsCount === 4
                        ? <Col className="col-xs-3" key="stepOffsetCol"></Col>
                        : null
                    }
                    {this.props.showTabs ?
                        this.props.certificationSteps.map((ps) => {

                            let color = "#2A77E4";
                            if (ps.stepStatus === 'Not Started')
                                color = "darkslategray";
                            else if (ps.stepStatus === 'In Progress')
                                color = "#FF9900";
                            if (ps.isDisabled)
                                color = "gray";
                            
                            if (ps.isDisabled)
                                return null;

                            return (
                                <Col className="col-xs-1-10 text-center" key={ps.stepCode}>
                                    <p style={{ fontSize: '13px' }}>
                                        {this.props.currentStepInfo.stepCode === ps.stepCode ?
                                            <strong>{ps.title}</strong> : ps.title}
                                    </p>
                                    {this.props.currentStepInfo.stepCode === ps.stepCode ?
                                        (<FontAwesomeIcon icon={[ps.iconLibrary, ps.icon]} size="3x" style={{ color: color }} className="my-icon" />)
                                        :
                                        (!ps.isDisabled) ?
											<Button type="button" bsStyle="link" onClick={() => this.handleStepNavigation(ps.stepCode, true)}>
                                                <FontAwesomeIcon icon={[ps.iconLibrary, ps.icon]} size="3x" style={{ color: color }} />
											</Button>
                                            :
                                            <FontAwesomeIcon icon={[ps.iconLibrary, ps.icon]} size="3x" style={{ color: color }} />
                                    }
                                    <p style={{ fontSize: '13px' }}>
                                        {this.props.currentStepInfo.stepCode === ps.stepCode ?
                                            <strong>{ps.stepStatus}</strong> : ps.stepStatus}
                                    </p>
                                </Col>
                            )
                        })
                        : null}
                </Row>
            </React.Fragment>
        )
    }
}

export default Navigator;


// WEBPACK FOOTER //
// ./src/areas/certification/comps/Navigator.js